import React from "react";
import {
  Box,
  Tab,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  Typography,
  useTheme,
  Alert,
} from "@mui/material";
import NavBar from "../../components/navbar/navbar";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import Carousel from "../../components/carousel/carousel";
import { CardContainer, OfferBox, StyledTabs } from "./styles";
import FooterBar from "../../components/footerBar/footerBar";
import InfoCard from "../../components/infoCard/infocard";
import {
  addSpaceBeforeCapitalsAndFirstNumber,
  API_URL,
  planNames,
  sanitize,
  sanitizePlays,
  sentActionLog,
  verify,
} from "../../utils/common";
import {
  Competitor,
  Offer,
  OffersTabs,
  Plans,
  SearchResponse,
  Square,
  CarouselHome,
} from "./types";
import { useLocation, useNavigate } from "react-router-dom";
import SelectNestedList from "../../components/selectNestedList/selectNestedList";
import { NestedListState } from "../../components/selectNestedList/types";
import nestedItemsReducer from "../../components/selectNestedList/reducer";
import { catalog } from "../../models";
import useUser from "../../hooks/useUser";
import Carousel0 from "../../assets/banner0.png";
import Carousel1 from "../../assets/banner1.jpg";
import Carousel2 from "../../assets/banner2.jpg";
import Banner from "../../assets/banner.png";
import swal from "sweetalert";
 

const labels: Record<string, string> = {
  zip: "Código postal",
  state: "Estado",
  zone: "Hub",
};

const keys: Record<string, string> = {
  zip: "codigo_postal",
  state: "id_plaza",
  zone: "id_plaza",
};

const initialState: NestedListState = {
  first: [],
  second: [],
  third: [],
};

const Home = () => {

  const [searchValue, setSearchValue] = React.useState<string>("");
  const [radioValue, setRadioValue] = React.useState<string>("zip");
  const [residentialOffers, setResidentialOffers] = React.useState<
    Plans | undefined
  >(undefined);
  const [bussinessOffers, setBussinessOffers] = React.useState<
    Plans | undefined
  >(undefined);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isLoadingList, setIsloadingList] = React.useState<boolean>(true);
  const [state, dispatch] = React.useReducer(nestedItemsReducer, initialState);
  const [competitors, setCompetitors] = React.useState<Array<Competitor>>([]);
  const [square, setSquare] = React.useState<Square | undefined>(undefined);
  const [plays, setPlays] = React.useState<catalog[]>([]);
  const [classifications, setClassifications] = React.useState<catalog[]>([]);
  const [offerTab, setOfferTab] = React.useState<string>("");
  const [offers, setOffers] = React.useState<OffersTabs>({});
  const [banners, setBanners] = React.useState<
    { [key: string]: string[] } | undefined
  >(undefined);
  const [tab, setTab] = React.useState<number>(1);
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { user } = useUser();
  const [carouselHomeBanners, setCarouselHomeBanners] = React.useState<CarouselHome[]>([]);
  const [isLoadingCarousel, setIsLoadingCarousel] = React.useState<boolean>(false);


  const handleSearch = React.useCallback(
    (radioVal = undefined, searchVal = undefined) => {
      if (searchValue === "" && searchVal === undefined) {
        alert("Error: Selecciona un Hub o ingresa un código postal");
      } else {
        setIsLoading(true);
        const token = localStorage.getItem("jwt");
        const params = new URLSearchParams({
          [keys[radioVal || radioValue]]: searchVal || searchValue,
        });
        if (radioVal === "zip" || radioValue === "zip") {
          sentActionLog(
            "Busqueda",
            `busqueda de ofertas ${params.toString()}`,
            undefined,
            searchVal || searchValue
          );
        } else {
          sentActionLog(
            "Busqueda",
            `busqueda de ofertas ${params.toString()}`,
            searchVal || searchValue
          );
        }
        fetch(`${API_URL}/plazas/ofertas?${params.toString()}`, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
            "content-type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((response: SearchResponse) => {
            if (response.error) {
              swal({ title: "Error", icon: "error", text: response.error });
            } else {
              const firstKey: string = Object.keys(
                response.ofertas
              )[0] as string;
              setOfferTab(firstKey);
              setOffers(response.ofertas);
              setResidentialOffers(response.ofertas[firstKey]!.residencial);
              setBussinessOffers(response.ofertas[firstKey]!.negocios);
              setCompetitors(response.competidores);
              setSquare({
                region: response.region,
                estado: response.estado,
                hub: response.hub,
                plaza: response.plaza,
                tipoPlaza: response.tipoPlaza,
                marca: response.marca,
              });
              setBanners(response.bannersUrls);
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            swal({
              title: "Error",
              icon: "error",
              text: "Hubo un error contacta a soporte",
            });
            console.error(err);
          });
      }
    },
    [radioValue, searchValue]
  );

  const getStates = React.useCallback(() => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/estados`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setIsloadingList(false);
        setIsLoading(false);
        dispatch({ type: "SET_FIRST", payload: response });
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const getHubsByState = (idState: number) => {
    const token = localStorage.getItem("jwt");
    const params = new URLSearchParams({
      id_estado: idState.toString(),
    });
    fetch(`${API_URL}/hubs?${params.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        dispatch({ type: "SET_SECOND", payload: response });
        setIsloadingList(false);
      })
      .catch((err) => console.error(err));
  };

  const getSquareByHub = (idHub: number) => {
    const token = localStorage.getItem("jwt");
    const params = new URLSearchParams({
      id_hub: idHub.toString(),
    });
    fetch(`${API_URL}/plazas?${params.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        dispatch({ type: "SET_THIRD", payload: response });
        setIsloadingList(false);
      })
      .catch((err) => console.error(err));
  };

  const getPlays = React.useCallback(() => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/plays`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setPlays(response);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const getClassifications = React.useCallback(() => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/clasificaciones`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setClassifications(response);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue("");
    setRadioValue(e.currentTarget.value);
  };

  const handleSelectedNestedChange = (
    value: number,
    level: "first" | "second" | "third"
  ) => {
    switch (level) {
      case "first":
        setIsloadingList(true);
        getHubsByState(value);
        break;
      case "second":
        setIsloadingList(true);
        getSquareByHub(value);
        break;
      case "third":
        setSearchValue(value.toString());
        break;
      default:
        console.error("Error: level not found");
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const handleOfferTabChange = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setOfferTab(newValue);
    setResidentialOffers(offers[newValue]!.residencial);
    setBussinessOffers(offers[newValue]!.negocios);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // NUEVA FUNCIÓN: Obtener banners del carrusel home
    const getCarouselHomeBanners = React.useCallback(() => {
      setIsLoadingCarousel(true);
      const token = localStorage.getItem("jwt");
      
      fetch(`${API_URL}/carrusel/downloads/banners`, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((response: CarouselHome[]) => {
          // Filtrar solo los banners activos y que existan en S3 y DB
          const activeBanners = response.filter(
            (banner) => banner.activo && banner.existsInS3 && banner.existsInDB
          );
          
          // Ordenar por fecha de creación (más recientes primero)
          // Cuando tengas el campo 'orden', puedes ordenar por ese campo
          const sortedBanners = activeBanners.sort((a, b) => {
            // Si tienen orden, usar ese
            if (a.orden !== undefined && b.orden !== undefined) {
              return a.orden - b.orden;
            }
            // Si no, ordenar por fecha de creación (más reciente primero)
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
          });
          
          setCarouselHomeBanners(sortedBanners);
          setIsLoadingCarousel(false);
        })
        .catch((err) => {
          console.error("Error al cargar banners del carrusel:", err);
          setIsLoadingCarousel(false);
          // Si falla, mantener el array vacío y se usarán las imágenes por defecto
        });
    }, []);

  const carouselElements = React.useMemo(() => {
    if (banners && banners[offerTab]) {
      return banners[offerTab].map((item) => {
        return <img src={item} alt="carouselImage" />;
      });
    }

        // Si hay banners del carrusel home de la BD, usar esos
    if (carouselHomeBanners.length > 0) {
      return carouselHomeBanners.map((banner, index) => (
        <img 
          key={`carousel-banner-${index}`} 
          src={banner.url} 
          alt={banner.fileName} 
        />
      ));
    }


    return [
      <img src={Carousel0} alt="carouselImage" />,
      <img src={Carousel1} alt="carouselImage" />,
      <img src={Carousel2} alt="carouselImage" />,
    ];
  }, [banners, offerTab, carouselHomeBanners]);

  const renderCards = (plans: Plans, tab: number) => {
    let items: Offer[] = [];
    switch (tab) {
      case 1:
        items = plans["3p"] || [];
        break;
      case 2:
        items = plans["2p"] || [];
        break;
      case 3:
        items = plans.izzitv || [];
        break;
      case 4:
        items = plans.dth || [];
        break;
      case 5:
        items = plans.movil || [];
        break;
      case 6:
        items = plans["2pIzzitv"] || [];
        break;
      case 7:
        items = plans["sp"] || [];
        break;
      case 11:
        items = plans["2pm"] || [];
        break;
      case 12:
        items = plans["3pm"] || [];
        break;
      case 13:
        items = plans["2pIzzitv3p"] || [];
        break;
      case 14:
        items = plans["2pIzzitvLight3p"] || [];
        break;
      case 15:
        items = plans["1pm"] || [];
        break;
      case 16:
        items = plans["2pIzzitvMovil3pm"] || [];
        break;
      default:
        items = plans["2p"] || [];
        break;
    }
    if (!items.length) {
      return <Alert severity="error">No hay información disponible :c</Alert>;
    }
    return items.map((item, index) => (
      <InfoCard
        width="257px"
        info={item}
        zipCode={searchValue}
        radioValue={radioValue}
        planName={planNames[item.play]}
        competitors={competitors}
        hasMargin={true}
        hasSeeMore={true}
      />
    ));
  };

  const renderTabs = React.useMemo(() => {
    let setted = false;
    return plays.map((item) => {
      const render = Boolean(
        residentialOffers?.[sanitizePlays(item.label)]?.length
      );
      if (render && !setted) {
        setted = true;
        setTab(item.value);
      }
      return (
        render && (
          <Tab
            onClick={() =>
              sentActionLog(
                "Play",
                `Clic en Tab ${item.label}`,
                undefined,
                undefined,
                undefined,
                item.value
              )
            }
            label={item.label}
            id={`simple-tab-${item.value}`}
            value={item.value}
            aria-controls={`simple-tabpanel-${item.value}`}
          />
        )
      );
    });
  }, [plays, residentialOffers]);

  const renderOffersTabs = () => {
    const arrayOffersTypes = classifications.map(
      (item) => sanitize(item.label) as string
    );
    return arrayOffersTypes.map((item) => {
      if (offers[item]) {
        return (
          <Tab
            label={addSpaceBeforeCapitalsAndFirstNumber(item)}
            id={`simple-tab-${item}`}
            value={item}
            aria-controls={`simple-tabpanel-${item}`}
          />
        );
      }
      return undefined;
    });
  };

  React.useEffect(() => {
    (async () => {
      if (!["/", "/login"].includes(location.pathname)) {
        const currentToken = localStorage.getItem("jwt");
        if (currentToken) {
          const isValid = await verify(currentToken);
          if (!isValid) {
            navigate("/");
          }
        } else {
          navigate("/");
        }
      }
    })();
  }, [location.pathname, navigate]);

  React.useEffect(() => {
    getStates();
    getPlays();
    getClassifications();
    getCarouselHomeBanners(); // NUEVA LLAMADA
    sentActionLog("Visit_Home", "Entro en la vista Home");
  }, [getClassifications, getPlays, getStates,getCarouselHomeBanners]);

  React.useEffect(() => {
    if (
      location.state?.searchValue &&
      location.state?.radioValue &&
      searchValue === ""
    ) {
      handleSearch(location.state.radioValue, location.state.searchValue);
      setSearchValue(location.state.searchValue);
      setRadioValue(location.state.radioValue);
      navigate("/Home", { replace: true });
    }
  }, [handleSearch, location, navigate, radioValue, searchValue]);

  if (isLoading) {
    return (
      <Stack spacing={1} style={{ padding: theme.spacing(1.5) }}>
        <Skeleton variant="rounded" height={30} />
        <Box display={"flex"}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box width={"100%"}>
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          </Box>
        </Box>
        <Skeleton variant="rounded" height={60} />
        <Skeleton variant="rounded" height={60} />
        <Skeleton variant="rounded" height={60} />
        <Skeleton variant="rounded" height={80} />
      </Stack>
    );
  }

  return (
    <>
      <CardContainer theme={theme}>
        <NavBar />
        <Box m={3}>
          <Typography variant="h5">Hola,</Typography>
          <Box display="flex" gap={theme.spacing(1)}>
            <Typography variant="h5" fontWeight="bold">
              {user?.firstName} {user?.lastName}
            </Typography>
            <span style={{ color: "#fbce3f" }}>
              <WavingHandIcon />
            </span>
          </Box>
          <RadioGroup
            row
            aria-labelledby="row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={radioValue}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="zip"
              control={<Radio size="small" color="secondary" />}
              label="Código postal"
              slotProps={{
                typography: {
                  variant: "body2",
                },
              }}
            />
            <FormControlLabel
              value="state"
              control={<Radio size="small" color="secondary" />}
              label="Estado"
              slotProps={{
                typography: {
                  variant: "body2",
                },
              }}
            />
            <FormControlLabel
              value="zone"
              control={<Radio size="small" color="secondary" />}
              label="Hub"
              slotProps={{
                typography: {
                  variant: "body2",
                },
              }}
            />
          </RadioGroup>
          {radioValue === "zip" ? (
            <FormControl variant="standard" fullWidth={true}>
              <OutlinedInput
                onChange={(e) => setSearchValue(e.currentTarget.value)}
                onKeyDown={handleKeyDown}
                value={searchValue}
                fullWidth={true}
                placeholder={`Buscar por ${labels[radioValue]}`}
                style={{ borderRadius: "10px" }}
                size="small"
                color="secondary"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="search"
                      onClick={() => handleSearch()}
                      edge="end"
                    >
                      <ArrowForwardIcon color="secondary" />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          ) : (
            <SelectNestedList
              placeholder={`Buscar por ${labels[radioValue]}`}
              items={state}
              onChangeItem={handleSelectedNestedChange}
              isLoading={isLoadingList}
              onSearch={handleSearch}
            />
          )}
        </Box>
        {square && (
          <Box ml={3} mt={-2}>
            <Typography variant="body2" display="flex" alignItems="center">
              {square.estado}
              <ArrowForwardIcon fontSize="small" color="secondary" />
              {square.hub}
              <ArrowForwardIcon fontSize="small" color="secondary" />
              {square.plaza}
            </Typography>
            <Typography variant="body2">
              {square.tipoPlaza} - {square.marca}
            </Typography>
          </Box>
        )}
        <Box ml={1} mr={1}>
          <StyledTabs
            style={{ position: "sticky", zIndex: 100 }}
            value={offerTab}
            onChange={handleOfferTabChange}
            indicatorColor="secondary"
            textColor="secondary"
          >
            {renderOffersTabs()}
          </StyledTabs>
          
          {!square || banners?.[offerTab]?.length || carouselHomeBanners.length  ? (
            <Box>
              {isLoadingCarousel && !square ? (
                <Skeleton variant="rounded" height={200} sx={{ m: 1, borderRadius: '10px' }} />
              ) : (
                <Carousel elements={carouselElements} />
              )}
            </Box>
          ) : (
            <Box>
              <img
                style={{ maxWidth: "95%", borderRadius: "10px", margin: "8px" }}
                src={Banner}
                alt="carouselImage"
              />
            </Box>
          )}
          {(residentialOffers || bussinessOffers) && (
            <>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }} mb={2}>
                <StyledTabs
                  value={tab}
                  onChange={handleTabChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                >
                  {renderTabs}
                </StyledTabs>
              </Box>
              {residentialOffers && (
                <Typography fontWeight="bold">
                  Ofertas para Residenciales
                </Typography>
              )}
              <OfferBox theme={theme}>
                {residentialOffers && renderCards(residentialOffers, tab)}
              </OfferBox>
              {bussinessOffers && (
                <Typography fontWeight="bold">Ofertas para Negocios</Typography>
              )}
              <OfferBox theme={theme}>
                {bussinessOffers && renderCards(bussinessOffers, tab)}
              </OfferBox>
            </>
          )}
        </Box>
      </CardContainer>
      <FooterBar active={0} />
    </>
  );
};

export default Home;
